// Default search values for the contact messages search form
export const searchValues = {
  phoneNumber: "",
  messageTitle: "",
};

// Mapping of Excel header names to the corresponding data fields
export const excelHeaderCellsName = {
  "المعرف": "id",
  "تاريخ الإرسال": "sendingDate",
  "نص الرسالة": "body",
  "تم الإرسال": "isSent",
  "رقم هاتف المستلم": "recipientPhoneNumber",
  "اسم المستلم": "reipientDisplayName",
};
